import React, { Component } from 'react';
import { Form, Radio, Modal, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
const { confirm } = Modal;
const api = services.api;
class Sendgoods extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    showModal = (sendOrderNo) => {
        console.log(sendOrderNo);
        const { entity } = this.props;
        // const { selectedKeys } = this.state;
        //     let sendOrderNo = selectedKeys.join(',');

        const content = (
            <div style={{ padding: '10px 0' }}>
                <div style={{ marginBottom: '15px', fontWeight: 'bold' }}>请选择快递公司</div>
                <Radio.Group name={'radioGroup'} defaultValue="JD" style={{ marginBottom: '15px' }}>
                    <Radio value="JD" style={{ marginRight: '20px' }}>
                        京东快递
                    </Radio>
                    <Radio value="SF">顺丰快递</Radio>
                </Radio.Group>
                <div style={{ color: '#666', fontSize: '12px' }}>
                    系统将根据您选择的快递公司，自动通过接口请求快递下单
                </div>
            </div>
        );
        confirm({
            title: '操作提示',
            content: content,
            onOk() {
                const selectedExpress = document.querySelector('input[name="radioGroup"]:checked')
                    ?.value;
                api.get(
                    {},
                    {
                        apiPath: `/8001/order/batch_delivery_new?send_order_nos=${sendOrderNo}&express_code=${selectedExpress}`,
                    }
                )
                    .then(() => {
                        const expressName = selectedExpress === 'JD' ? '京东' : '顺丰';
                        message.success(`发货成功(${expressName})`);
                        entity.search({
                            ...entity.params,
                            ...entity.filters,
                        });
                    })
                    .catch(errorHandle);
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        this.setState({
            visible: true,
        });
    };

    handleOk = (e) => {
        console.log(this.props.entity);
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let value;
                value = {
                    sale_num_status: values.saleNumStatus,
                };
                api.put(value, { apiPath: `/products/${this.props.rows.id}` })
                    .then(() => {
                        message.success('修改成功');
                    })
                    .catch(errorHandle);
                this.setState({
                    visible: false,
                });
                let params = {
                    type: 'FK_POINTS',
                };
                // 列表数据刷新
                this.props.x.search({
                    ...params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    render() {
        const {
            rows: { deliveryStatus, sendOrderNo },
        } = this.props;
        const { visible, inputVisible } = this.state;
        return (
            <div>
                {deliveryStatus == 1 && (
                    <a target="_blank" onClick={() => this.showModal(sendOrderNo)}>
                        发货
                    </a>
                )}
            </div>
        );
    }
}

export default Form.create()(Sendgoods);
